import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';
import { ProductBasicResponse } from '@pdp/common';
import { isPlatformBrowser } from '@angular/common';

// Get product from Localstorage

@Injectable({
  providedIn: 'root'
})
export class WishilistService {

  // wishlist array
  public wishlistProducts: BehaviorSubject<ProductBasicResponse[]> = new BehaviorSubject([]);
  public observer: Subscriber<{}>;
  public products = [];// = localStorage ? JSON.parse(localStorage.getItem("wishlistItem")) || [] : [];

  // Initialize 
  constructor(
    @Inject(PLATFORM_ID) private platformId: string) {
    this.wishlistProducts.subscribe(products => products = products);
  }

  // Get  wishlist Products
  public getProducts(): Observable<ProductBasicResponse[]> {
    const itemsStream = new Observable(observer => {
      observer.next(this.products);
      observer.complete();
    });
    return <Observable<ProductBasicResponse[]>>itemsStream;
  }

  // If item is aleready added In wishlist
  public hasProduct(product: ProductBasicResponse): boolean {
    const item = this.products.find(item => item.id === product.id);
    return item !== undefined;
  }

  // Add to wishlist
  public addToWishlist(product: ProductBasicResponse): ProductBasicResponse | boolean {
    var item: ProductBasicResponse | boolean = false;
    if (this.hasProduct(product)) {
      item = this.products.filter(item => item.id === product.id)[0];
      const index = this.products.indexOf(item);
    } else {
      this.products.push(product);
    }
    // this.toastrService.success($localize`:@@Success:Success`); // toasr services
    if (isPlatformBrowser(this.platformId)) {
      // localStorage.setItem("wishlistItem", JSON.stringify(this.products));
    }
    return item;
  }

  // Removed Product
  public removeFromWishlist(product: ProductBasicResponse) {
    if (product === undefined) { return; }
    const index = this.products.indexOf(product);
    this.products.splice(index, 1);
    if (isPlatformBrowser(this.platformId)) {
      // localStorage.setItem("wishlistItem", JSON.stringify(this.products));
    }
  }
}
